<template>
  <v-container class="ma-0 pa-0" style="width: 100%" :style="isOnMobile ? 'max-height: 320px' : 'max-height: 500px'" fluid>
    <v-col v-if="freeTexts" class="ma-0 pa-2" align="center" justify="center">
      <t-button v-if="freeTexts.length > 2" btnText="Изтегли файл" btnIcon="mdi-download" @click.native="saveTelemetry()" />
      <v-row class="ma-0 pa-0" v-for="(txt, k) in freeTexts" :key="k">
        <span class="subtitle" style="white-space: pre">{{ txt }}</span>
      </v-row>
    </v-col>

    <v-row v-else-if="editMode" class="ma-0 pa-0 box-container" justify="center" style="max-height: 60vh; max-width: 100%">
      <v-row class="ma-0 pa-0 row-content">
        <v-col v-if="productsNames.length > 0" :cols="ingredientsNames.length > 0 ? 6 : 12" :lg="ingredientsNames.length > 0 ? 6 : 12" :md="ingredientsNames.length > 0 ? 6 : 12" sm="12" xs="12" class="ma-0 pa-0 px-2">
          <v-divider></v-divider>
          <v-row class="ma-0 pa-0" justify="center">
            <span class="subtitle">Списък продукти:</span>
          </v-row>
          <v-divider></v-divider>
          <v-row class="ma-0 pa-0" justify="center" v-for="(prod, x) in productsNames" :key="'prod' + x">
            <v-text-field :value="device.TelemetryProducts[x]" :label="prod" hide-details />
          </v-row>
        </v-col>
        <v-col v-if="ingredientsNames.length > 0" :cols="productsNames.length > 0 ? 6 : 12" :lg="productsNames.length > 0 ? 6 : 12" :md="productsNames.length > 0 ? 6 : 12" sm="12" xs="12" class="ma-0 pa-0 px-2">
          <v-divider></v-divider>
          <v-row class="ma-0 pa-0" justify="center">
            <span class="subtitle">Списък съставки:</span>
          </v-row>
          <v-divider></v-divider>
          <v-row class="ma-0 pa-0" justify="center" v-for="(ing, u) in ingredientsNames" :key="'ing' + u">
            <v-text-field :value="device.TelemetryIngredients[u]" :label="ing" hide-details />
          </v-row>
        </v-col>
        <v-divider></v-divider>
      </v-row>
      <v-row class="ma-0 pa-0 row-header" justify="end">
        <t-button :btnText="'Отказ'" :class="'ma-1 pa-0'" :btnIcon="'mdi-close'" @click.native="cancelEditMode()" />
        <t-button :btnText="'OK'" :class="'ma-1 pa-0'" :btnIcon="'mdi-check-bold'" @click.native="updateDevInfo()" />
      </v-row>
    </v-row>
    <div v-else class="box-container ma-0 pa-0">
      <v-row v-if="!diff" class="row-header ma-0 mx-3 pa-0" align="center" justify="space-between">
        <v-radio-group class="ma-0 pa-0" v-model="fromLastReset" hide-details>
          <v-radio :value="true" label="От последното зануляване"></v-radio>
          <v-radio :value="false" label="От иницализацията"></v-radio>
        </v-radio-group>
        <t-button :class="'ma-0 ml-4 pa-0'" :btnText="isOnMobile ? 'Редакция продукти и съставки' : 'Редакция на продукти и съставки'" :btnIcon="'mdi-pencil'" @click.native="editMode = true" />
      </v-row>
      <div class="row-content ma-0 pa-0">
        <v-expansion-panels class="ma-0 pa-0" multiple :value="expanded" v-for="(panel, i) in expandos" :key="i">
          <v-expansion-panel class="ma-0 pa-0" v-show="panel.itemsCount > 0">
            <v-divider class="ma-0 pa-0"></v-divider>
            <v-expansion-panel-header class="ma-0 pa-0 px-3" align="center" justify="center">{{ panel.title }}</v-expansion-panel-header>
            <v-expansion-panel-content class="ma-0 pa-0">
              <apex-chart class="ma-0 pa-0" :width="isOnMobile ? '240px' : chartWidth" type="bar" :height="panel.itemsCount * 20 + 50 + 'px'" :options="panel.chartOptions" :series="panel.chartSeries"></apex-chart>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </div>
  </v-container>
</template>
<script>
import DataManager, { chart_locales } from "../../js/DataManager";
import { saveAs } from "file-saver";

export default {
  props: {
    freeTexts: {
      type: Array,
      default: null,
    },
    diff: {
      type: Boolean,
      default: false,
    },
    device: {
      type: Object,
    },
    telemetryData: {
      type: Object,
    },
  },
  data() {
    return {
      fromLastReset: !this.diff,
      editMode: false,
      chartWidth: "100%",
      expanded: [0, 1, 2, 3],
      max_y: undefined,
      productsTurnoverSeries: [{ name: "Оборот", data: [] }],
      productsQtySeries: [{ name: "Продадено количество", data: [] }],
      coinsSeries: [{ name: "Брой монети", data: [] }],
      ingredientsSeries: [{ name: "Изразходвано количество", data: [] }],
      productsTurnoverCategories: [],
      productsNames: [],
      ingredientsNames: [],
      productsQtyCategories: [],
      coinsCategories: [],
      ingredientsCategories: [],
      zzBackground: "#FFF",
      zzForeground: "#000",
      zzTheme: "light",
    };
  },
  computed: {
    expandos() {
      return [
        {
          title: "Продадени продукти - " + this.productsQtySeries[0].data.sum() + " бр.",
          chartOptions: {
            theme: {
              mode: this.zzTheme,
            },
            chart: {
              defaultLocale: "bg",
              locales: chart_locales,
              id: "Products-Chart",
              type: "line",
              background: this.zzBackground,
              foreColor: this.zzForeground,
              toolbar: {
                download: this.getIconString("mdi-download"),
              },
            },
            plotOptions: {
              bar: {
                horizontal: true,
              },
            },
            stroke: {},
            xaxis: {
              categories: this.productsQtyCategories,
            },
            yaxis: {
              seriesName: "Income",
              //opposite: true,
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: "#05733F",
              },
              labels: {
                style: {
                  colors: "#05733F",
                },
              },
              title: {
                //text: "Продадено количество",
                style: {
                  color: "#05733F",
                },
              },
              max: this.max_y,
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return val;
                },
              },
            },
          },
          chartCategories: this.productsQtyCategories,
          chartSeries: this.productsQtySeries,
          itemsCount: this.productsQtySeries[0].data.length,
        },
        {
          title: "Оборот от продукти - " + this.productsTurnoverSeries[0].data.sum().toFixed(2) + " €",
          chartOptions: {
            chart: {
              defaultLocale: "bg",
              locales: chart_locales,
              id: "Products-Chart",
              type: "line",
            },
            plotOptions: {
              bar: {
                horizontal: true,
              },
            },
            stroke: {},
            xaxis: {
              categories: this.productsTurnoverCategories,
            },
            yaxis: {
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: "#008FFB",
              },
              labels: {
                // formatter: function(val) {
                //   return val.toFixed(2) + "€ ";
                // },
                // style: {
                //   colors: "#008FFB",
                // },
              },
              title: {
                //text: "Оборот",
                // style: {
                //   color: "#008FFB",
                // },
              },
              tooltip: {
                enabled: true,
              },
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return val.toFixed(2) + " €";
                },
              },
            },
          },
          chartCategories: this.productsTurnoverCategories,
          chartSeries: this.productsTurnoverSeries,
          itemsCount: this.productsTurnoverSeries[0].data.length,
        },
        {
          title: "Изразходвани съставки - Общо " + this.ingredientsSeries[0].data.sum() + "",
          chartOptions: {
            chart: {
              defaultLocale: "bg",
              locales: chart_locales,
              id: "Ingredients-Chart",
            },
            plotOptions: {
              bar: {
                horizontal: true,
              },
            },
            xaxis: {
              categories: this.ingredientsCategories,
            },
          },
          chartCategories: this.ingredientsCategories,
          chartSeries: this.ingredientsSeries,
          itemsCount: this.ingredientsSeries[0].data.length,
        },
        {
          title:
            "Нива на монетите в тубите - Общо " +
            this.coinsSeries[0].data
              .map((val, idx) => val * this.coinsCategories[idx])
              .sum()
              .roundTo(2)
              .toFixed(2) +
            " €",
          chartOptions: {
            chart: {
              defaultLocale: "bg",
              locales: chart_locales,
              id: "Coins-Chart",
            },
            plotOptions: {
              bar: {
                horizontal: true,
              },
            },
            xaxis: {
              categories: this.coinsCategories,
            },
            yaxis: {
              axisTicks: {
                show: true,
              },
              labels: {
                formatter: function (val) {
                  return val.toFixed(2) + " €";
                },
              },
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return val + " бр.";
                },
              },
            },
          },
          chartCategories: this.coinsCategories,
          chartSeries: this.coinsSeries,
          itemsCount: this.coinsSeries[0].data.length,
        },
      ];
    },
  },
  methods: {
    saveTelemetry() {
      var blob = new Blob([this.freeTexts.join("\r\n")], { type: "text/plain;charset=utf-8" });
      saveAs(blob, "Telemetry_" + this.device.sn + "_" + this.device.Name.replace(" ", "_") + ".txt");
    },
    getIconString(icon) {
      return '<i class="v-icon notranslate mdi ' + icon + " theme--" + this.zzTheme + '" style="font-size: 32px; z-index: 13;"/></i>';
    },
    updateDevInfo() {
      DataManager.updateDevProfile(this.device);
      this.refreshInfo();
      this.cancelEditMode();
    },
    cancelEditMode() {
      this.editMode = false;
      this.chartWidth = "99%";
      this.$nextTick(() => {
        this.chartWidth = "100%";
      });
    },
    refreshInfo() {
      if (this.isInDarkMode) {
        this.zzBackground = "#1E1E1E";
        this.zzForeground = "#FFF";
        this.zzTheme = "dark";
      } else {
        this.zzBackground = "#FFF";
        this.zzForeground = "#000";
        this.zzTheme = "light";
      }

      this.productsNames = [];
      this.ingredientsNames = [];
      this.ingredientsCategories = [];
      this.coinsCategories = [];
      this.productsQtyCategories = [];
      this.productsTurnoverCategories = [];
      this.ingredientsSeries[0].data = [];
      this.coinsSeries[0].data = [];
      this.productsQtySeries[0].data = [];
      this.productsTurnoverSeries[0].data = [];

      this.$nextTick(() => {
        // if (this.device.TelemetryProducts.length == 0) {
        //   var tmpProd = [];
        //   this.telemetryData.Products.forEach(pr => {
        //     tmpProd.push(pr.Name);
        //   });
        //   this.device.TelemetryProducts = tmpProd;
        // }
        // if (this.device.TelemetryIngredients.length == 0) {
        //   var tmpIng = [];
        //   this.telemetryData.Ingredients.forEach(ing => {
        //     tmpIng.push(ing.Name);
        //   });
        //   this.device.TelemetryIngredients = tmpIng;
        // }
        this.telemetryData.CoinTypes.forEach((c) => {
          this.coinsCategories.push(c.ValueOfCoin);
          this.coinsSeries[0].data.push(c.NumberOfCoinsinTube);
        });
        for (var u = 0; u < this.telemetryData.Products.length; u++) {
          var p = this.telemetryData.Products[u]; //p.Price ?
          this.productsNames.push(p.Name);
          this.productsQtyCategories.push(p.Name); //this.device.TelemetryProducts[u]);
          this.productsTurnoverCategories.push(p.Name); //this.device.TelemetryProducts[u]);
          this.productsQtySeries[0].data.push(this.fromLastReset ? p.NumberOfPaidProductsVendedSinceLastReset : p.NumberOfPaidProductsVendedSinceInit);
          this.productsTurnoverSeries[0].data.push((this.fromLastReset ? p.ValueOfPaidProductSalesSinceLastReset : p.ValueOfPaidProductSalesSinceInit) / 100);
        }
        for (var i = 0; i < this.telemetryData.Ingredients.length; i++) {
          var d = this.telemetryData.Ingredients[i];
          this.ingredientsNames.push(d.Name);
          this.ingredientsCategories.push(d.Name); //this.device.TelemetryIngredients[i]);
          this.ingredientsSeries[0].data.push(this.fromLastReset ? d.QuantitySinceLastReset : d.QuantitySinceInit);
        }
        // var mx = Math.max(...this.telemetryData.Products.map(f => f.MaximumProductCapacity));
        // if (mx > 0) this.max_y = mx;
      });
    },
  },
  watch: {
    fromLastReset() {
      this.refreshInfo();
    },
  },
  created() {
    this.refreshInfo();
  },
  mounted() {
    // console.log(this.freeTexts);
  },
};
</script>

<style scoped>
/* .v-expansion-panel >>> .v-expansion-panel-content__wrap {
  padding: 0px;
  margin: 0px;
} */
</style>